import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var invertirOnlineTitleEntities = function invertirOnlineTitleEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_INVERTIRONLINETITLEVIEWBYINVERTIRONLINETITLEIDANDAUTHUSERID_SUCCESS:
      var byId = action.response.invertirOnlineTitleById;
      return merge({}, state, {
        byId: byId
      });
    default:
      return state;
  }
};
export default invertirOnlineTitleEntities;